import { FC } from "react";

import { styled } from "@mui/material/styles";

import logo from "./ic-divider.png";

const StyledDivider = styled("img")(() => {
  return {
    maxWidth: "100%",
    objectFit: "cover",
  };
});

const Divider: FC = () => {
  return <StyledDivider src={logo} />;
};

export default Divider;
